document.addEventListener("DOMContentLoaded", function () {
  function alertMX(t) {
    $("body").append(
      $("<div id='boxMX'><p class='msgMX'></p><p id='closeMXN'>CLOSE</p></div>")
    );
    $(".msgMX").text(t);
    var popMargTop = ($("#boxMX").height() + 24) / 2,
      popMargLeft = ($("#boxMX").width() + 24) / 2;
    $("#boxMX")
      .css({ "margin-top": -popMargTop, "margin-left": -popMargLeft })
      .fadeIn(200);
    $("#boxMX").click(function () {
      $(this).remove();
    });
  }
  const radioButtons = document.getElementsByName("option");
  const addToCartButtons = document.querySelectorAll(".product-form__submit");
  let radioButtonValue;
  var newAddtoCart = false;
  //const productId = {{ product.id }};
  for (let i = 0; i < radioButtons.length; i++) {
    radioButtons[i].addEventListener("change", function () {
      if (this.value === "yes") {
        radioButtonValue = "yes";
        console.log("Inside yes");
        newAddtoCart = true;
        // for (const button of addToCartButtons) {
        //   button.addEventListener("click", function (event) {
        //     console.log("add to cart clicked!");
        //     event.preventDefault();
        //   });
        // }
      } else {
        radioButtonValue = "no";
        console.log("Inside no");
        newAddtoCart = false;
      }
    });
  }
  const radioButton = document.querySelector('input[name="option"]');

  for (const button of addToCartButtons) {
    button.addEventListener("click", function (event) {
      //console.log("add to cart clicked!");
      event.preventDefault();
      this.querySelector(".loading-overlay__spinner").classList.remove(
        "hidden"
      );
      this.setAttribute("aria-disabled", true);
      console.log(radioButtonValue);
      if (radioButtonValue == "yes") {
        console.log("custom Add to cart");
        //const productId = form.querySelector(
        //  "[class='product-variant-id']"
        // ).value;
        const form = button.closest("form"); // Get the closest form element
        const formData = $(form).serialize();
        $.ajax({
          type: "POST",
          url: "https://shopify.purplecommerce.live/customaddtocart/AD69kcEAAA",
          data: formData,
          dataType: "json",
          success: (res) => {
            //const result = JSON.parse(res);
            const quantity = 1;
            const productId = res.pid;
            const successStatus = res.success;
            //alert(result);
            if (successStatus == true && productId != 0) {
              console.log(productId);
              var type = document.getElementById("monogram_type").value;
              var color_name = document.getElementById("color_name").value;
              var font_name = document.getElementById("font_name").value;
              var monogram_text =
                document.getElementById("monogram_text").value;
              var additional_charge =
                document.getElementById("additional_charge").value;

              const xhr = new XMLHttpRequest();
              xhr.open("POST", "/cart/add.js");
              xhr.setRequestHeader("Content-Type", "application/json");

              xhr.onload = function () {
                if (xhr.status === 200) {
                  console.log("Product added to cart successfully!");
                  //alertMX("Product successfully added to cart.");

                  // setTimeout(function () {
                  window.location.href = "/cart";
                  // }, 5000);
                } else {
                  // Handle errors
                  console.error("Error adding to cart:", xhr.statusText);
                  alert("Error adding to cart:", xhr.statusText);
                }
              };

              xhr.send(
                JSON.stringify({
                  quantity,
                  id: productId,
                  properties: {
                    Type: type,
                    Color: color_name,
                    Font: font_name,
                    Text: monogram_text,
                  },
                })
              );
              this.removeAttribute("aria-disabled", true);
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
              console.log("From server!!");
            } else {
              alert("Something went wrong. Please try again!!");
            }
          },
          error: (xhr, status, error) => {
            console.error(error);
          },
        });
      } else {
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        console.log("Normal add to cart");
        button.form.submit();
      }
    });
  }

  $(document).on("click", "#closeMXN", function () {
    location.reload();
  });
});
